import { render, staticRenderFns } from "./HotTeacherList.vue?vue&type=template&id=36d0b100&scoped=true&"
import script from "./HotTeacherList.vue?vue&type=script&lang=js&"
export * from "./HotTeacherList.vue?vue&type=script&lang=js&"
import style0 from "./HotTeacherList.vue?vue&type=style&index=0&id=36d0b100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d0b100",
  null
  
)

export default component.exports